import React from 'react';

import { Pill, type PillTone } from '@/components/common/Pill';
import { TIER_LABELS, type EscalationLogEntry, type TierLabel } from '@/models/escalation.model';
import { formatDate } from '@/utils/format';

export interface NotificationHistoryRowProps {
  entry: EscalationLogEntry;
}

const TIER_TONE: Record<TierLabel, PillTone> = {
  PM: 'info',
  DL: 'warning',
  OWNER: 'error',
  CL: 'error',
  CONFIRMED: 'success',
};

export function NotificationHistoryRow({
  entry,
}: Readonly<NotificationHistoryRowProps>): React.ReactElement {
  const tier = entry.tier as TierLabel;
  const names = (entry.recipients ?? []).map((r) => r.name);
  const nameText = names.length > 0 ? names.join(', ') : TIER_LABELS[tier];

  return (
    <div className="notification-history-row">
      <span
        className={`notification-history-row__bullet notification-history-row__bullet--${tier}`}
        aria-hidden="true"
      />
      <div className="notification-history-row__content">
        <div className="notification-history-row__name-line">
          <span className="notification-history-row__label">{nameText}</span>
          <Pill tone={TIER_TONE[tier]} size="small">
            {tier}
          </Pill>
        </div>
        <span className="notification-history-row__meta">
          Notified {formatDate(entry.notifiedDate)}
        </span>
      </div>
    </div>
  );
}
